import { render, staticRenderFns } from "./ComprehensiveInformationQuery.vue?vue&type=template&id=735e4ef3&scoped=true"
import script from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
export * from "./ComprehensiveInformationQuery.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveInformationQuery.vue?vue&type=style&index=0&id=735e4ef3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e4ef3",
  null
  
)

export default component.exports